import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { PaymentTestView } from "@containers/payment/PaymentTestView";

const PaymentTestPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="">
            <PaymentTestView />
        </AuthenticatedLayout>
    );
}

export default PaymentTestPage;